import messageUtils from "@utils/messageUtils";
import axios from "axios";

export const state = {
  transmitterInfo: null,
  shouldFetchTransmitterInfos: false,
  transmitterInfoCache: {},
};

export const actions = {
  async getSensorTransmitterInfo({ commit, state }, payload) {
    const cacheKey = payload;

    if (state.transmitterInfoCache[cacheKey]) {
      return state.transmitterInfoCache[cacheKey];
    }

    try {
      const response = await axios.get(`/v1/sensor_transmitter_infos${payload}`);
      commit("setTransmitterInfoCache", { key: cacheKey, data: response.data });
      return response.data;
    } catch (error) {
      messageUtils.showErrors(error);
      return Promise.reject(error);
    }
  },
};

export const mutations = {
  setTransmitterInfo(state, transmitterInfo) {
    state.transmitterInfo = transmitterInfo;
  },

  setShouldFetchTransmitterInfos(state, value) {
    state.shouldFetchTransmitterInfos = value;
  },

  setTransmitterInfoCache(state, { key, data }) {
    state.transmitterInfoCache = { ...state.transmitterInfoCache, [key]: data };
  },

  clearTransmitterInfoCache(state) {
    state.transmitterInfoCache = {};
  },
};
